import types from "./types";
import { ThunkDispatch } from "redux-thunk";
import api from "constants/api";
import _get from "lodash/get";
import { string } from "joi";
import { createStatistic } from 'store/app/actions';

export interface HmoAwvMetricsModel {
  providerId: string;
  companyId: string;
  measureYear: number;
}

export interface MemberBatchUpdateModel {
  memberIds: string[];
  awvStatus: string;
  measureYear: number;
  memberType: string;
  userId: string;
}

export interface MemberPafModelResponse {
  documents: [
    {
      created_time: string;
      pdfBase64: any;
    }
  ];
}
export interface MemberPafModel {
  memberIds: string[];
  companyId: string;
  memberType: string;
}
export interface MemberExcelStatusModel {
  providerId: string;
  companyId: string;
  memberType: string;
  measureYear: number;
  filter: string[];
}

export interface RefreshMemberAwvStatusModel {
  providerId: string;
  companyId: string;
  measureYear: number;
  memberType: any;
  userId: string;
  provKey: string;
}

export interface HmoAwvMetricsResponse {
  RmiMeasureCode: string;
  RmiMeasureName: string;
  RmiCompleted: number;
  RmiIncomplete: number;
  RmiModifiedDate: string;
  RmiCutpoint1: number;
  RmiCutpoint2: number;
  RmiCutpoint3: number;
  RmiCutpoint4: number;
  RmiCutpoint5: number;
  RmiMeasureWeight: number;
  RmiStarRating: number;
  YeartoDateRaf: string;
  ChronicRecaptureRate: string;
  AwvPendingCount: number;
}

export interface HmoMemberAwvDetailsModel {
  providerId: string;
  companyId: string;
  pageIndex: number;
  pageSize: number;
  measureYear: number;
  memberType: any;
  memberName: string;
  filter: string[];
}

export interface MemberMpiSearchModel {
  memberKeyId: string;
  companyId: string;
}

export const getMemberAwvDetails =
  (payload: HmoMemberAwvDetailsModel) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.GET_HMO_AWV_REQUEST, payload });

    return api.hmo
      .getMemberAwvDetails(payload)
      .then((res: any) => {
        dispatch({
          type: types.GET_HMO_AWV_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.GET_HMO_AWV_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };

export const getHmoAwvMetrics =
  (payload: HmoAwvMetricsModel) => (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.GET_MEMBER_MPI_REQUEST, payload });

    return api.hmo
      .getHmoAwvMetrics(payload)
      .then((res: any) => {
        dispatch({
          type: types.GET_MEMBER_MPI_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.GET_MEMBER_MPI_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };


export const getMemberMpi =
  (payload: MemberMpiSearchModel) => (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.GET_HMO_METRICS_REQUEST, payload });

    return api.hmo
      .getMemberMpi(payload)
      .then((res: any) => {
        dispatch({
          type: types.GET_HMO_METRICS_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.GET_HMO_METRICS_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
};

export const updateMemberAwvStatus =
  (payload: MemberBatchUpdateModel) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.UPDATE_HMO_METRICS_REQUEST, payload });

    return api.hmo
      .updateMemberAwvStatus(payload)
      .then((res: any) => {
        dispatch({
          type: types.UPDATE_HMO_METRICS_SUCCESS,
          payload: res,
        });

        dispatch(createStatistic(
          'MIGRATION', 
          sessionStorage.getItem('ipaGroup')!, 
          1, 
          'AWV UPDATE SUCCESS', 
          sessionStorage.getItem('user_id')! 
        ));

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.UPDATE_HMO_METRICS_FAILURE,
          payload,
        });

        dispatch(createStatistic(
          'MIGRATION', 
          sessionStorage.getItem('ipaGroup')!, 
          1, 
          'AWV UPDATE FAILURE', 
          sessionStorage.getItem('user_id')! 
        ));

        return Promise.reject(payload);
      });
  };

export const refreshMemberAwvStatus =
  (payload: RefreshMemberAwvStatusModel) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.REFRESH_MEMBER_AWV_STATUS_REQUEST, payload });

    return api.hmo
      .refreshMemberAwvStatus(payload)
      .then((res: any) => {
        dispatch({
          type: types.REFRESH_MEMBER_AWV_STATUS_SUCCESS,
          payload: res,
        });

        dispatch(createStatistic(
          'MIGRATION', 
          sessionStorage.getItem('ipaGroup')!, 
          1, 
          'AWV VISIT', 
          sessionStorage.getItem('user_id')! 
        ));

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.REFRESH_MEMBER_AWV_STATUS_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };

export const downloadMemberPafs =
  (payload: MemberPafModel) => (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.DOWNLOAD_MEMBER_PAFS_REQUEST, payload });

    return api.hmo
      .downloadMemberPafs(payload)
      .then((res: any) => {
        dispatch({
          type: types.DOWNLOAD_MEMBER_PAFS_SUCCESS,
          payload: res,
        });

        dispatch(createStatistic(
          'MIGRATION', 
          sessionStorage.getItem('ipaGroup')!, 
          1, 
          'AWV PAF DOWNLOAD', 
          sessionStorage.getItem('user_id')! 
        ));

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.DOWNLOAD_MEMBER_PAFS_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };

export const downloadAwvStatusExcel =
  (payload: MemberExcelStatusModel) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.MEMBER_STATUS_EXCEL_REQUEST, payload });

    return api.hmo
      .downloadAwvStatusExcel(payload)
      .then((res: any) => {
        dispatch({
          type: types.MEMBER_STATUS_EXCEL_SUCCESS,
          payload: res,
        });

        dispatch(createStatistic(
          'MIGRATION', 
          sessionStorage.getItem('ipaGroup')!, 
          1, 
          'AWV EXCEL DOWNLOAD', 
          sessionStorage.getItem('user_id')! 
        ));

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.MEMBER_STATUS_EXCEL_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
    };

export const downloadAwvStatusPdf =
  (payload: MemberExcelStatusModel) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.MEMBER_STATUS_PDF_REQUEST, payload });

    return api.hmo
      .downloadAwvStatusPdf(payload)
      .then((res: any) => {
        dispatch({
          type: types.MEMBER_STATUS_PDF_SUCCESS,
          payload: res,
        });

        dispatch(createStatistic(
          'MIGRATION', 
          sessionStorage.getItem('ipaGroup')!, 
          1, 
          'AWV PDF DOWNLOAD', 
          sessionStorage.getItem('user_id')! 
        ));

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.MEMBER_STATUS_PDF_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };
